import React, {
  useCallback,
  useEffect,
  useState,
  useRef,
} from 'react';
import SearchResult from './search_result';

const search_result_event_detail = (props) => {
  const [searchConditions, setSearchConditions] = useState({
    page: 1,
    prefKey: props.prefKey,
    keyword: props.keyword,
    circleOrder: '',
    eventCondition: 'event',
    eventDate: null,
  });
  const [circles, setCircles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingNextList, setIsLoadingNextList] = useState(false);
  const [isLastPage, setIsLastPage] = useState(false);
  const ancScrollPositionRef = useRef(null);

  const handleScrollEvent = useCallback(
    () => {
      const ancPosition = ancScrollPositionRef.current.offsetTop;
      const scrolled = $(window).scrollTop();

      if (
        scrolled > ancPosition - 2000
      ) {
        firstLoad();
      }
    },
    [ancScrollPositionRef, firstLoad]
  );

  const apiCall = useCallback(
    ({ page, prefKey, keyword, circleOrder, eventCondition, eventDate }) => {
      $.ajax({
        url: '/api/circle/search',
        dataType: 'json',
        cache: false,
        data: {
          page,
          pref_key: prefKey,
          keyword,
          order: circleOrder,
          event_condition: eventCondition,
          event_date: eventDate,
        },
        success: function (data) {
          if (page === 1) {
            // 1ページ目
            setCircles(data.circles);
          } else if (page >= 2) {
            // 2ページ目以降
            setCircles((prev) => [...prev, ...data.circles]);
          }
          setSearchConditions({
            page,
            prefKey,
            keyword,
            circleOrder,
            eventCondition,
            eventDate,
          });
          setIsLoading(false);
          setIsLoadingNextList(false);
          setIsLastPage(data.isLastPage);

        },
        error: function () {
          setIsLoading(false);
          setIsLoadingNextList(false);
        },
      });
    },
    [
      setCircles,
      setSearchConditions,
      setIsLoading,
      setIsLoadingNextList,
      setIsLastPage
    ]
  );

useEffect((
  () => {
    window.addEventListener('scroll', handleScrollEvent);
    if (isLoading) {
      return;
    }
    setIsLoading(true);
  }
),[handleScrollEvent]);

  // 初回ロード
  const firstLoad = useCallback(() => {
    window.removeEventListener('scroll', handleScrollEvent);
    apiCall({
      page: 1,
      prefKey: searchConditions.prefKey,
      keyword: searchConditions.keyword,
      circleOrder: searchConditions.circleOrder,
      eventCondition: searchConditions.eventCondition,
      eventDate: searchConditions.eventDate
    });
  }, [
    searchConditions, handleScrollEvent, apiCall
  ]);

  // スクロール時
  const loadNextList = useCallback(() => {
    if (isLoading || isLoadingNextList || isLastPage) {
      return;
    }
    setIsLoadingNextList(true);
    apiCall({
      ...searchConditions,
      page: searchConditions.page + 1,
    });
  }, [
    isLoading,
    isLoadingNextList,
    isLastPage,
    setIsLoadingNextList,
    apiCall,
    searchConditions,
  ]);

  return (
    <React.Fragment>
    <div className="bg-white mb-5">
      <div id="ancScrollPosition" ref={ancScrollPositionRef} />
      <div id="search-result-wrapper">
        {isLoading ? (
          <div className="text-center">
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        ) : (
          <SearchResult
            searchTitle={'類似のイベント'}
            circles={circles}
            loadNextList={loadNextList}
            isLoadingNextList={isLoadingNextList}
            isLastPage={isLastPage}
            currentUser={props.currentUser}
          />
        )}
      </div>
    </div>
    </React.Fragment>
  );
};

export default search_result_event_detail;
